// extracted by mini-css-extract-plugin
export var linkText = "_m8-0";